module.exports = __webpack_public_path__ + "static/media/negative-image.4d127775.jpeg";